export const sentryDsn = process.env.REACT_APP_SENTRY_DSN;
export const sentryEnv = process.env.REACT_APP_SENTRY_ENV;
export const sentryTracesSampleRate =
  process.env.REACT_APP_SENTRY_TRACES_SAMPLE_RATE;
